import { FormField } from '@/_components';
import { CardContainer, FormMediaInput, ImageTextHeader, useMedia } from '@/_containers';
import { PageHeaderContainer } from '@/_containers/headers/page/page-header-container';
import type { OnPartialUpdate } from '@/_schemas/types';
import { nameResolver } from '@/_shared';

import { useRecruitingFormContext } from '../../form-context';
import type { RecruitingMutationSchema } from '../../schemas';

export function Header({
  onPartialUpdate,
  isEditable,
}: {
  isEditable: boolean;
  onPartialUpdate: OnPartialUpdate<RecruitingMutationSchema>;
}) {
  const form = useRecruitingFormContext();
  const [first_name, last_name, id] = form.watch(['first_name', 'last_name', 'id']);
  const folder_path = `recruiting/${id}`;

  const { onImageUpdate } = useMedia(onPartialUpdate);

  return (
    <CardContainer bodyClassName="flex">
      <PageHeaderContainer>
        <ImageTextHeader
          imageSlot={
            <FormField
              control={form.control}
              name="profile_image"
              render={({ field: { ref: _, ...field } }) => (
                <FormMediaInput
                  {...field}
                  size="lg"
                  shape="circle"
                  label=""
                  disabled={!isEditable}
                  folder_path={folder_path}
                  onImageStateChange={onImageUpdate}
                />
              )}
            />
          }
          primarySlot={nameResolver(first_name, last_name)}
        />
      </PageHeaderContainer>
    </CardContainer>
  );
}
